import React, { useState, useRef, useEffect } from 'react'

// Generic components
import SweetAlert from '../../genericComponents/ModalConfirmacion';
import Formulario from '../../genericComponents/Formulario';
import Preloader from '../../genericComponents/Preloader';

import { Switch, Redirect, useParams } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui icons
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import HelpIcon from '@material-ui/icons/Help';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ErrorIcon from '@material-ui/icons/Error';

import styles from "../../assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

import { asyncHandleFocus, handleErrorInputText } from '../../helpers/handles';
import { info, warning, primary, danger, success } from '../../helpers/colores';

const useStyles = makeStyles(styles);

function CambiarPassword({ isToken, updatePassword, rgxPassword, loginFondo }) {

    const classes = useStyles();

    const { token } = useParams();

    const cleanDisabled = { password: false, cambiar: true, iniciar: false };
    const cleanState = { confirmarpassword: "", password: "" };
    const cleanErrorState = {
        password: { error: false, helperText: ""  },
        confirmarpassword: { error: false, helperText: ""  }
    };
    const cleanInfo = {
        message: "Aquí capture su nueva contraseña, recuerde que tiene 5 minutos (desde la solicitud de este correo) para poder realizar el cambio. Puede intentarlo las veces que sea necesario; siempre y cuando sea dentro de los 5 minutos.",
        icon: HelpIcon,
        color: primary
    };

    const [state, setState] = useState(cleanState);
    const [infoInput, setInfoInput] = useState(cleanInfo);
    const [componente, setComponente] = useState(null);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [errorToken, setErrorToken] = useState(true);
    const [loader, setLoader] = useState(false);
    const [disabled, setDisabled] = useState(cleanDisabled);
    const [alert, setAlert] = useState(null);

    const title = "Actualizar/recuperar contraseña";
    const grid = { xs:12, sm: 12, md: 5, lg: 4 };

    let passwordRef = useRef(null);
    let confirmarpasswordRef = useRef(null);
    let cambiarRef = useRef(null);

    const inputs = [{
        disabled: disabled.password,
        id: "password",
        value: state.password,
        error: errorState.password.error,
        success: state.password && !errorState.password.error ? true : undefined,
        helperText: errorState.password.helperText,
        title: "Nueva contraseña",
        placeholder: "Capture su nueva contraseña",
        icono: <VpnKeyIcon />,
        inputProps: { type: "password" },
        inputRef: passwordRef,
        onChange: ({target:{value}}) => handleState(value, "password"),
        onKeyDown: (evt) => asyncHandleFocus(evt, confirmarpasswordRef, true, ftCambiarPassword)
    }, {
        disabled: disabled.password,
        id: "confirmarpassword",
        value: state.confirmarpassword,
        error: errorState.confirmarpassword.error,
        success: state.confirmarpassword && !errorState.confirmarpassword.error ? true : undefined,
        helperText: errorState.confirmarpassword.helperText,
        title: "Confirmar contraseña",
        placeholder: "Vuelva a capturar su nueva contraseña",
        icono: <VpnKeyIcon />,
        inputProps: { type: "password" },
        inputRef: confirmarpasswordRef,
        onChange: ({target:{value}}) => handleState(value, "confirmarpassword"),
        onKeyDown: (evt) => asyncHandleFocus(evt, cambiarRef, false, ftCambiarPassword)
    }];

    let botonPassword = errorToken ? [] : [{
        loader,
        disabled: errorToken,
        icono: ArrowRightIcon,
        color: info,
        descripcion: "Actualizar contraseña",
        onClick: ftCambiarPassword,
        inputRef: cambiarRef
    }];

    const acciones = [...botonPassword, {
        disabled: disabled.iniciar,
        icono: ArrowRightIcon,
        color: warning,
        descripcion: "Ir a Iniciar sesión",
        onClick: () => setComponente(<><Switch><Redirect from={"*"} to={"/"} /></Switch></>)
    }];

    function handleState(value, id) {
        setState(state => ({
            ...state,
            [id]: value
        }));
    }

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }){
        return handleErrorInputText({ cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, errorState: setErrorState });
    }

    function handleValidaciones({ password, confirmarpassword }) {

        let error;
        let validaciones = [{
            condicion: !rgxPassword.test(password),
            ref: passwordRef, keyError: "password",
            mensajeError: "La estructura de la contraseña debe contener una letra mayúscula, una letra minúscula, un número, un caracter especial y de 8 a 30 caracteres"
        }, {
            condicion: password !== confirmarpassword, ref: confirmarpasswordRef, keyError: "confirmarpassword",
            mensajeError: "La contraseña de confirmación no es igual a la contraseña capturada"
        }];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if(error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if(error) return error;

    }

    function ftCambiarPassword() {
        async function cambiarPassword() {
            setLoader(true);
            setDisabled(disabled => ({
                ...disabled,
                password: true,
                iniciar: true
            }));
            try {

                let { password, confirmarpassword } = state;

                let error = await handleValidaciones({ password, confirmarpassword });

                if(error) {
                    setDisabled(cleanDisabled);
                    return error;
                }

                let cambio = await updatePassword({ password }, token);

                if(!cambio) throw new Error("Ocurrió un error al cambiar la contraseña");

                setAlert({
                    descripcion: "Hemos podido actualizar tu contraseña correctamente en unos segundos te redireccionaremos a la ventana de inicio para que puedas iniciar tu sesión; si no deseas esperar presiona el siguiente botón",
                    title: "¡Contraseña actualizada!",
                    tipo: success,
                    msjConfirmacion: "¡Gracias!",
                    onConfirm: () => setComponente(<><Switch><Redirect from={"*"} to={"/"} /></Switch></>)
                });

                setTimeout(() => setComponente(<><Switch><Redirect from={"*"} to={"/"} /></Switch></>), 3000);

            } catch({message}) {
                setAlert({
                    descripcion: message,
                    title: "¡Te pedimos una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "De acuerdo",
                    onConfirm: () => setAlert(null)
                });
            }
            setLoader(false);
            setDisabled(cleanDisabled);
        } return cambiarPassword();
    }

    function ftEffect() {
        async function effect() {
            let errorInfo = {
                message: `Lamentablemente el enlace para cambiar la contraseña ya ha caducado; si aún desea cambiar su contraseña de clic en "Ir a Iniciar" sesión para solicitar un correo nuevo`,
                icon: ErrorIcon,
                color: danger,
                error: true
            };
            try {
                let hasToken = await isToken(token);
                !!hasToken ? setInfoInput(cleanInfo) : setInfoInput(errorInfo);
                setErrorToken(!!!hasToken);
                setComponente(true);
            } catch({message}) {
                console.error(message);
                setInfoInput(errorInfo);
                setErrorToken(true);
                setComponente(true);
            }
        } effect();
    }

    useEffect(ftEffect, [token]);

    return (
        componente === null ? <Preloader /> : (componente === true ? <div
            className={classes.fullPage}
            style={{ backgroundImage: "url(" + loginFondo + ")" }}
        >
            <Formulario
                title={title}
                icono={<LockOpenIcon />}
                grid={grid}
                inputs={infoInput.error ? null : inputs}
                acciones={acciones}
                focus={infoInput.error ? null : passwordRef}
                color={primary}
                info={infoInput}
            />
            { alert && <SweetAlert
                title={alert.title}
                descripcion={alert.descripcion}
                tipo={alert.tipo}
                msjConfirmacion={alert.msjConfirmacion}
                msjCancelacion={alert.msjCancelacion}
                onConfirm={alert.onConfirm}
                showConfirm={alert.showConfirm}
                showCancel={alert.showCancel}
                onCancel={() => setAlert(null)}
            /> }
        </div> : componente)
    );

}

export default CambiarPassword;
